import { isBlank } from "./diaryUtils";

const base = "rounded-xl border-2 font-semibold transition-colors duration-150 focus:outline-none focus-visible:ring-4 focus-visible:ring-sky-400";
const on = "border-zinc-900 bg-zinc-900 text-white";
const off = "border-zinc-300 bg-white text-zinc-900 hover:border-zinc-500";

/** 0–10 scale as tap targets; tapping the chosen number again clears it (blank ≠ 0). */
export function ScalePicker({ field, value, onChange, testId }) {
  return (
    <div>
      <div className="grid grid-cols-6 gap-2 sm:grid-cols-11" role="radiogroup" aria-label={field.prompt}>
        {Array.from({ length: 11 }, (_, n) => (
          <button key={n} type="button" role="radio" aria-checked={value === n} onClick={() => onChange(value === n ? null : n)}
                  data-testid={`${testId}-${n}`} className={`min-h-[48px] font-mono-num text-lg ${base} ${value === n ? on : off}`}>
            {n}
          </button>
        ))}
      </div>
      {field.help && <p className="mt-1.5 text-sm text-zinc-600">{field.help}</p>}
      {!isBlank(value) && (
        <button type="button" onClick={() => onChange(null)} className="mt-1 text-sm text-zinc-600 underline" data-testid={`${testId}-clear`}>
          Leave blank
        </button>
      )}
    </div>
  );
}

export function ChoicePills({ field, value, onChange, testId }) {
  return (
    <div className="flex flex-wrap gap-2" role="radiogroup" aria-label={field.prompt}>
      {field.options.map((o) => (
        <button key={o.value} type="button" role="radio" aria-checked={value === o.value}
                onClick={() => onChange(value === o.value ? null : o.value)} data-testid={`${testId}-${o.value}`}
                className={`min-h-[48px] px-4 text-base ${base} ${value === o.value ? on : off}`}>
          {o.label}
        </button>
      ))}
    </div>
  );
}

export function FieldInput({ field, value, onChange, testId }) {
  if (field.type === "rating") return <ScalePicker field={field} value={value} onChange={onChange} testId={testId} />;
  if (field.type === "single") return <ChoicePills field={field} value={value} onChange={onChange} testId={testId} />;
  const cls = "w-full rounded-xl border-2 border-zinc-300 bg-white p-3 text-lg focus:border-zinc-900 focus:outline-none focus-visible:ring-4 focus-visible:ring-sky-400";
  if (field.type === "integer") {
    return (
      <div className="flex items-center gap-3">
        <input inputMode="numeric" value={isBlank(value) ? "" : String(value)} data-testid={testId} aria-label={field.prompt}
               onChange={(e) => { const t = e.target.value.replace(/[^0-9]/g, ""); onChange(t === "" ? null : Number(t)); }}
               className={`${cls} w-32 font-mono-num`} />
        {field.unit && <span className="text-lg text-zinc-700">{field.unit}</span>}
      </div>
    );
  }
  const long = field.type === "long_text";
  const Tag = long ? "textarea" : "input";
  return (
    <div>
      <Tag value={value || ""} rows={long ? 3 : undefined} maxLength={long ? 2000 : 200} aria-label={field.prompt}
           onChange={(e) => onChange(e.target.value)} data-testid={testId} className={cls} />
      {field.help && <p className="mt-1.5 text-sm text-zinc-600">{field.help}</p>}
    </div>
  );
}
